import axios from 'axios';

import { Plugins } from '@capacitor/core';
const { Storage } = Plugins;
import { BASE_URL } from '@/constants/constants';

export default {
    state: {
        user: {},
        roles: [],
        groups: [],
        users: []
    },
    
    actions: {
        clearUserData({ commit }) {
            commit('setUser', {});
        },

        fetchUser({ commit, rootState }) {
            return new Promise((resolve, reject) => {
                let headers = {
                    'Authorization': rootState.authorization
                };

                axios.get(`${BASE_URL}/account/application/2/`, 
                    { headers: headers, params: {
    building: rootState.subscriptions.active_subscription.building
  } }).then((response) => {
                    commit('setUser', response.data);

                    resolve(response);
                }).catch((error) => {
                    reject(error);
                });
            });
        },

        getUserData({ commit }) {
            return new Promise((resolve, reject) => {
                Storage.get({ key: 'user' }).then((response) => {
                    let user = JSON.parse(response.value);
                    
                    if (user) {
                        commit('setUser', user);
                        resolve();
                    } else {
                        reject();
                    }
                });
            });
        },

        updateUserData({ commit, rootState }, data) {
            return new Promise((resolve, reject) => {
                let headers = {
                    'Authorization': rootState.authorization
                };
                axios.put(`${BASE_URL}/account/application/1/`, data, { headers: headers }).then((response) => {
                    // commit('updateContactStore', response.data);
                    console.log("response",response.data)
                    resolve(response.data);
                }).catch((error) => {
                    if (error.response && error.response.data && error.response.data.error) {
                        reject(error.response.data.error);
                    } else {
                        reject(error);
                    }
                });
            });
        },

        checkEmail({ commit, rootState }, data) {
            return new Promise((resolve, reject) => {
                axios.post(`${BASE_URL}/app/password-recovery/email-check`, data).then((response) => {
                    // commit('updateContactStore', response.data);
                    console.log("response",response.data)
                    resolve(response.data);
                }).catch((error) => {
                    if (error.response && error.response.data && error.response.data.error) {
                        reject(error.response.data.error);
                    } else {
                        reject(error);
                    }
                });
            });
        },


        securityQuestion({ commit, rootState }, data) {
            return new Promise((resolve, reject) => {
                axios.put(`${BASE_URL}/app/password-recovery/security-check`, data).then((response) => {
                    // commit('updateContactStore', response.data);
                    console.log("response",response.data)
                    resolve(response.data);
                }).catch((error) => {
                    if (error.response && error.response.data && error.response.data.error) {
                        reject(error.response.data.error);
                    } else {
                        reject(error);
                    }
                });
            });
        },

        resetPassword({ commit, rootState }, data) {
            return new Promise((resolve, reject) => {
                axios.patch(`${BASE_URL}/app/password-recovery/reset-password`, data).then((response) => {
                    // commit('updateContactStore', response.data);
                    console.log("response",response.data)
                    resolve(response.data);
                }).catch((error) => {
                    if (error.response && error.response.data && error.response.data.error) {
                        reject(error.response.data.error);
                    } else {
                        reject(error);
                    }
                });
            });
        },

        deleteAccount({ commit, rootState }) {
            return new Promise((resolve, reject) => {
                let headers = {
                    'Authorization': rootState.authorization
                };
                axios.delete(`${BASE_URL}/account/application/1/`, { headers: headers }).then((response) => {
                    // commit('updateContactStore', response.data);
                    console.log("response",response.data)
                    resolve(response.data);
                }).catch((error) => {
                    if (error.response && error.response.data && error.response.data.error) {
                        reject(error.response.data.error);
                    } else {
                        reject(error);
                    }
                });
            });
        },
    },

    mutations: {
        setUser(state, data) {
            state.user = data;
            
            Storage.set({
                key: 'user',
                value: JSON.stringify(data)
            });
        }
    },

    getters: {

        getUser: (state) => {
            return state.user;
        },

        getAuthorizationHeaders: (state, getters, rootState) => {
            return rootState.authorization;
        },
    }
};